import { INITIAL_UPDATE_REQUEST, FINAL_UPDATE_REQUEST, FETCH_UPDATES_SUCCESS, DELETE_UPDATE_SUCCESS, SAVE_UPDATE_SUCCESS, ERROR } from "../types/updates.types";

const initialState = {
	updates: [],
	post_details: [],
	loading: false,
	error: null,
	total: 0,
	last_page: 0,
	from: 0,
	to: 0,
	current_page: 0,
};

function updates(state = initialState, action) {
	switch (action.type) {
		case INITIAL_UPDATE_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case FINAL_UPDATE_REQUEST:
			return {
				...state,
				loading: false,
			};
		case FETCH_UPDATES_SUCCESS:
			return {
				...state,
				loading: false,
				updates: action.payload.updates,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				post_details: action.payload.post_details,
				current_page: action.payload.current_page,
			};
		case SAVE_UPDATE_SUCCESS:
			return {
				...state,
				loading: false,
				updates: action.payload.updates,
			};
		case DELETE_UPDATE_SUCCESS:
			return {
				...state,
				loading: false,
				updates: action.payload.updates,
			};
		case ERROR:
			return {
				...state,
				loading: false,
				error: action.paylaod.error,
				updates: [],
			};
		default:
			return state;
	}
}

export default updates;
